export const REINICIAR_ESTADO_STORE = "REINICIAR_ESTADO_STORE";
export const DISPLAY_LOADING = "DISPLAY_LOADING";
export const UPDATE_TAREAS_PENDIENTES = "UPDATE_TAREAS_PENDIENTES";
export const UPDATE_DATOS_HISTORICO_EMPLEADOS =
    "UPDATE_DATOS_HISTORICO_EMPLEADOS";
export const UPDATE_DATOS_EPIS_PENDIENTES_EMPLEADOS =
    "UPDATE_DATOS_EPIS_PENDIENTES_EMPLEADOS";
